import { render, staticRenderFns } from "./PartInfo.vue?vue&type=template&id=358aa5e2&scoped=true"
import script from "./PartInfo.ts?vue&type=script&lang=ts&external"
export * from "./PartInfo.ts?vue&type=script&lang=ts&external"
import style0 from "./PartInfo.scss?vue&type=style&index=0&id=358aa5e2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358aa5e2",
  null
  
)

export default component.exports